import script from "./About-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./About-popup.vue?vue&type=script&setup=true&lang=js"

import "./About-popup.vue?vue&type=style&index=0&id=4fb3e920&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb3e920"]])

export default __exports__